// Meta Pixel helper. The base code lives in public/index.html; this only forwards events.
let lastPath = null;
export const track = (event, params) => {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  window.fbq("track", event, params);
};
export const trackPageView = (pathname) => {
  // The base snippet already fired PageView for the first document load.
  if (lastPath === null) { lastPath = pathname; return; }
  if (lastPath === pathname) return;
  lastPath = pathname;
  track("PageView");
};
